'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentConstants = exports.PaymentConstants = (0, _keymirror2.default)({
    SHOW: null,
    SHOW_SUCCESS: null,
    SHOW_FAIL: null,

    PAY_INNER_PIPO_REQUEST: null,
    PAY_INNER_PIPO_SUCCESS: null,
    PAY_INNER_PIPO_FAIL: null,

    CHECK_CODE_SEND_INNER_PIPO_REQUEST: null,
    CHECK_CODE_SEND_INNER_PIPO_SUCCESS: null,
    CHECK_CODE_SEND_INNER_PIPO_FAIL: null,

    PAY_INNER_PIPO_RESET: null,

    PIPO_PROCESS_INPUT_REQUEST: null,
    PIPO_PROCESS_INPUT_SUCCESS: null,
    PIPO_PROCESS_INPUT_FAIL: null,
    PIPO_PROCESS_INPUT_RESET: null,

    SET_CUSTOM_PAYMENT: null,
    RESET_CUSTOM_PAYMENT: null,

    REPAYMENT_ORDER_REQUEST: null,
    REPAYMENT_ORDER_SUCCESS: null,
    REPAYMENT_ORDER_FAIL: null,

    PIPO_PAY_PARAMS_REQUEST: null,
    PIPO_PAY_PARAMS_SUCCESS: null,
    PIPO_PAY_PARAMS_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/payment.js
// module id = 1876
// module chunks = 0